function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP licence number
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { autoClub, membershipNumber } from '../../actions/index';
import Select from '../select/Select';
import TextInput from '../text-input/TextInput';
import { AUTO_CLUB } from '../../data/Data';
import './AutoClub.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class AutoClub extends React.Component {
  render() {
    const {
      club,
      setAutoClub,
      setMembershipNumber
    } = this.props;
    const showMembership = club.autoClub && ['', 'NA'].indexOf(club.autoClub.value) === -1 ? true : false;
    if (club.autoClub.value === '') club.autoClub.value = 'NA';
    return /*#__PURE__*/_jsxs("div", {
      className: "form-element-container AutoClub",
      children: [/*#__PURE__*/_jsx(Select, {
        label: "Auto club membership",
        options: AUTO_CLUB,
        name: "autoClub",
        section: "personal-details",
        handleChange: setAutoClub,
        onBlur: setAutoClub
        // $FlowFixMe
        ,
        values: club
      }), showMembership ? /*#__PURE__*/_jsx(TextInput, {
        handleChange: setMembershipNumber,
        onBlur: setMembershipNumber,
        label: "Membership number",
        name: "membershipNumber",
        section: "personal-details"
        // $FlowFixMe
        ,
        values: club
      }) : null]
    });
  }
}
_defineProperty(AutoClub, "defaultProps", {
  autoClub: {
    value: ''
  },
  membershipNumber: {
    value: ''
  }
});
const mapStateToProps = ({
  club
}) => {
  return {
    club
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setAutoClub: value => {
      dispatch(autoClub(value));
    },
    setMembershipNumber: value => {
      dispatch(membershipNumber(value));
    }
  };
};
const VisibleAutoClub = connect(mapStateToProps, mapDispatchToProps)(AutoClub);
export default VisibleAutoClub;